import { TableCell, TableSortLabel } from '@mui/material'
import React from 'react'

interface OrderableTableCellProps<T> {
  disabled?: boolean
  keyName: keyof T
  onChangeOrder: (keyName: keyof T) => void
  order?: 'asc' | 'desc'
  orderBy?: keyof T
  width?: string | number
}

export default function OrderableTableCell<T>({
  children,
  disabled = false,
  keyName,
  onChangeOrder,
  order,
  orderBy,
  width
}: React.PropsWithChildren<OrderableTableCellProps<T>>) {
  return (
    <TableCell
      sortDirection={orderBy === keyName ? order : false}
      sx={theme => ({ color: theme.palette.primary.main, ...(width ? { width, minWidth: width } : {}) })}
    >
      <TableSortLabel
        active={orderBy === keyName}
        direction={orderBy === keyName ? order : undefined}
        disabled={disabled}
        onClick={() => {
          onChangeOrder(keyName)
        }}
      >
        {children}
      </TableSortLabel>
    </TableCell>
  )
}
